"use client";

import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import styles from "./PartnersSection.module.css";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import PartIcon from "@/app/assets/partner.svg";

const partners = [
  "/part1.svg",
  "/part2.svg",
  "/part3.svg",
  "/part4.svg",
  "/part5.svg",
  "/part6.svg",
  "/part7.svg",
];

const PartnersSection = () => {
  const [current, setCurrent] = useState(1);

  return (
    <div className="container">
      <div className={styles.partnersWrapper}>
        {/* HEADER */}
        <div className={styles.header}>
          <div className={styles.leftBlock}>
            <span className={styles.icon}>
              <Image src={PartIcon} width={40} alt="..." />
            </span>
            <span className={styles.title}>Partners</span>
          </div>
        </div>

        {/* SLIDER */}
        <div className={styles.sliderContainer}>
          <Swiper
            slidesPerView={5}
            spaceBetween={20}
            navigation={{
              nextEl: ".nextBtn",
              prevEl: ".prevBtn",
            }}
            modules={[Navigation]}
            onSlideChange={(swiper) => setCurrent(swiper.activeIndex + 1)}
            breakpoints={{
              320: { slidesPerView: 1 },
              480: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
          >
            {partners.map((img, index) => (
              <SwiperSlide key={index}>
                <div className={styles.logoCard}>
                  <Image src={img} alt="Partner Logo" className="img-fluid" width={140} height={70} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* BOTTOM BAR */}
          <div className={styles.bottomBar}>
            <div className={styles.pageCounter}>
              <span className={styles.currentNum}>
                {String(current).padStart(2, "0")}
              </span>
              <span className={styles.totalNum}> / {partners.length}</span>
            </div>

            <div className={styles.arrows}>
              <button className={`prevBtn ${styles.arrowBtn}`}>
                <FaChevronLeft />
              </button>
              <button className={`nextBtn ${styles.arrowBtn}`}>
                <FaChevronRight />
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PartnersSection;
